import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const ActivityPlansProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `ActivityPlan/GetActivityPlanById/${props.activityPlanId}`, method: 'GET', secure: true });
    }, [execute]);

    const selectOnlyRecord = useCallback(async (props) => {
        await execute({ scope: 'selectonly', url: `ActivityPlan/GetActivityTemplateByOnlyPlanId/${props.activityPlanId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `ActivityPlan/CreateActivityPlan`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'edit', url: `ActivityPlan/EditActivityPlan`, method: 'POST', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        if(props && props.categoryId){
            await execute({ scope: 'list', url: `ActivityPlan/ActivityPlansByCategory?start=0&length=10000&categoryId=${props.categoryId}`, method: 'GET', secure: true });
        } else {
            await execute({ scope: 'list', url: `ActivityPlan/ActivityPlansByCategory?start=0&length=10000`, method: 'GET', secure: true });
        }
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `ActivityPlan/DeleteActivityPlan/${props.activityPlanId}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const listCategories = useCallback(async () => {
        await execute({ scope: 'listcategories', url: 'ActivityPlan/ActivityCategories', method: 'GET', secure: true });
    }, [execute]);  

    const value = {  listRecords, newRecord, createRecord, selectRecord, selectOnlyRecord, updateRecord, deleteRecord, data, listCategories, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useActivityPlansStore = () => React.useContext(Context);
